<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Unit</span>
                </div>
            </div>

        </div>

        <div class="row" style="padding-left: 15px; padding-right: 15px;">
            <div class="col-6 offset-3">
                <div class="container form-background">
                    <div class="row">
                        <div class=" col-12 text-left form-title">
                            <span class="row-table-font-margins">{{ formTitle }} for building {{ buildingName }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>Unit Number: *</label>
                            <input type="text"
                                   placeholder="Number"
                                   class="form-control"
                                   v-model="number" />
                            <div v-show="submitted && !number" class="invalid-feedback">
                                Unit number is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label>Floor:  *</label>
                            <select class="form-control" v-model="floor">
                                <option value="LG">LG</option>
                                <option value="G">G</option>
                                <option value="M">M</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </select>
                            <div v-show="submitted && !floor" class="invalid-feedback">
                                Floor is required
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Type:  *</label>
                            <select class="form-control" v-model="type">
                                <option value="1">Flat</option>
                                <option value="2">Shop</option>
                                <option value="3">Office</option>
                            </select>
                            <div v-show="submitted && !type" class="invalid-feedback">
                                Type is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label>Square Meters:</label>
                            <input style="width: 100%;"
                                   type="number"
                                   placeholder="Square Meters"
                                   class="form-control"
                                   v-model="squareMeters" />
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-6">
                            <label>Monthly fee:</label>
                            <input v-bind:disabled="!building.useMonthlyExpenses" style="width: 100%;"
                                   type="number"
                                   placeholder="Monthly Fee"
                                   class="form-control"
                                   v-model="monthlyFee" />
                        </div>
                        <div class="col-md-6">
                            <label>Starting From:</label>
                            <select name="startingMonth" v-model="startingMonth" id="" class="form-control">
                                <option v-for="(month,index) in months" :key="index" :value=month.id>{{month.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Full Name:  *</label>
                            <input type="text"
                                   name="name"
                                   v-model="contact.name"
                                   placeholder="Full Name"
                                   class="form-control" />
                            <div v-show="submitted && !contact.name"
                                 class="invalid-feedback ">
                                Contact name is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label>Email:  *</label>
                            <input type="email"
                                   name="email"
                                   v-model="contact.email"
                                   placeholder="Email"
                                   class="form-control" />
                            <div v-show="submitted && !contact.email"
                                 class="invalid-feedback ">
                                Contact email is required
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Phone number:  *</label>
                            <input type="text"
                                   name="phone_number"
                                   v-model="contact.phoneNumber"
                                   placeholder="Phone Number"
                                   class="form-control" />
                            <div v-show="submitted && !contact.phoneNumber"
                                 class="invalid-feedback ">
                                Contact phone number is required
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label>Management Company:  </label>
                            <input type="text"
                                   name="managementCompany"
                                   v-model="managementCompany"
                                   placeholder="Management Company"
                                   class="form-control" />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6">
                            <label>Contact Person:  </label>
                            <input type="text"
                                   name="contactPerson"
                                   v-model="contactPerson"
                                   placeholder="Contact Person"
                                   class="form-control" />
                        </div>
                        <div class="col-md-6">
                            <label>Phone Number:  </label>
                            <input type="text"
                                   name="phoneNumber"
                                   v-model="phoneNumber"
                                   placeholder="Phone Number"
                                   class="form-control" />
                        </div>
                    </div>
                </div>
                <div class="container form-background" style="margin-top:15px;">
                    <div class="row">
                        <div class="panel-body table-responsive">
                            <template v-for="post in propertyHistory"
                                               >
                                <div class="row">
                                    <div class="col-md-6">
                                        <label>Year</label>
                                        <input class="form-control text-right"
                                               v-model="post.year"
                                               number />
                                    </div>
                                    <!-- <div class="col-md-3"> -->
                                        <!-- <label>Total to Pay</label>
                                        <input class="form-control text-right"
                                               v-model="post.statement"
                                               number
                                               data-type="currency" />
                                    </div>
                                    <div class="col-md-3">
                                        <label>Paid</label>
                                        <input class="form-control text-right"
                                               v-model="post.paid"
                                               number
                                               data-type="currency" />
                                    </div> -->
                                    <div class="col-md-6">
                                        <label>Balance</label>
                                        <input class="form-control text-right"
                                        v-model="post.balance"
                                               number
                                               
                                               data-type="currency" />
                                    </div>
                                    
                                </div>
                            </template>
                                    
                                    <input type="hidden"
                                           id="items"
                                           name="propertyHistory"
                                           v-model="propertyHistory" />
                                </div>
                            </div>
                        </div>
                <div class="text-right">
                    <button type="submit" @click="saveProperty()" class="btn btn-submit" style="margin: 15px;">
                        Submit
                    </button>
                    <button @click="cancel()" class="btn btn-cancel">Cancel</button>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
import { mapState } from "vuex";
export default {
  data: function () {
    return {
      number: "",
      monthlyFee: 0,
      type: 1,
      squareMeters: 0,
      buildingId: 0,
      startingMonth: 1,
     // buildingName: "",
      managementCompany: "",
      contactPerson: "",
      phoneNumber: "",
      floor: "LG",
      id: 0,
      submitted: false,
      formTitle: "Add new unit",
      isClone: false,
      contact: {},
      renterContact: {},
      propertyHistory: [],
      users: [],
      contactId: null,
      renterContactId: null,
      months: [],
    };
  },
  mounted() {
    //this.buildingName = this.$route.params.buildingName;
    if (this.$route.params.propertyId) {
      //this.formTitle = 'Edit Building';
      this.id = this.$route.params.propertyId;
      this.getMonths();
      this.getUsers();
      this.getProperty();
      if (this.$route.params.isClone) {
        this.formTitle = "Clone unit";
        this.isClone = this.$route.params.isClone;
      } else this.formTitle = "Update unit";
    } else {
      this.buildingId = this.$route.params.buildingId;
      this.propertyHistory.splice(0, 0, {});
      this.propertyHistory[0].year = new Date().getFullYear() - 1;
      this.propertyHistory[0].balance = 0;
      this.contact = { name: "", phoneNumber: "", email: "" };
      this.getMonths();
      this.getUsers();
    }
  },
  methods: {
    getMonths: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/months";
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then((response) => {
          this.mute = false;

          //this.contacts = data.contacts;
          this.months = response.data.months;
        });
    },
    getProperty: function () {
        this.$http.get("/properties/" + this.id).then((response) => {
        this.buildingId = response.data.buildingId;
        // this.buildingName = response.data.building.name,
        this.number = response.data.number;
        this.type = response.data.type;
        this.squareMeters = response.data.squareMeters;
        this.floor = response.data.floor;
        this.monthlyFee = response.data.monthlyFee;
        this.contact = response.data.contact;
        this.contactId = response.data.contactId;
        this.renterContact = response.data.renterContact;
        this.startingMonth = response.data.startingMonth;
        this.renterContactId = response.data.renterContactId;
        this.propertyHistory = response.data.propertyHistories;
        this.managementCompany = response.data.managementCompany;
        this.contactPerson = response.data.contactPerson;
        this.phoneNumber = response.data.phoneNumber;
          this.userId = response.data.userId;
        if (this.propertyHistory.length == 0)
          this.propertyHistory.splice(0, 0, {});
      });
    },
    getUsers: function () {
      this.$http.get("/users").then((response) => {
        this.users = response.data;
      });
    },
      saveProperty: function () {
          console.log("Building:" + this.building)
      var canSubmit =
        this.number &&
        this.floor &&
        this.type &&
        this.contact.name &&
        this.contact.email &&
        this.contact.phoneNumber;
      if (this.id && !this.isClone) {
        this.submitted = true;

        if (canSubmit)
          this.$http
            .put("/properties/" + this.id, {
              id: this.id,
              number: this.number,
              monthlyFee: this.monthlyFee,
              startingMonth: this.startingMonth,
              type: this.type,
              squareMeters: this.squareMeters,
              floor: this.floor,
              buildingId: this.buildingId,
              contact: this.contact,
              renterContact: this.renterContact,
              contactId: this.contactId,
              renterContactId: this.renterContactId,
              propertyHistories: this.propertyHistory,
              managementCompany: this.managementCompany,
              contactPerson: this.contactPerson,
                phoneNumber: this.phoneNumber,
              userId : this.userId
            })
            .then(
                () => {
                    console.log(this.building)
                    if (this.buildingId == 0 || this.buildingId == null)
                        this.$router.push("/buildings");
                    else
                this.$router.push({
                  name: "properties",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      } else {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .post("/properties", {
              number: this.number,
              monthlyFee: this.monthlyFee,
              startingMonth: this.startingMonth,
              type: this.type,
              squareMeters: this.squareMeters,
              floor: this.floor,
              buildingId: this.buildingId,
              contact: this.contact,
              contactId: this.contactId,
              renterContactId: this.renterContactId,
              renterContact: this.renterContact,
              propertyHistories: this.propertyHistory,
              managementCompany: this.managementCompany,
              contactPerson: this.contactPerson,
              phoneNumber: this.phoneNumber,

              //   contact:this.contact
            })
            .then(
                () => {
                    
                this.$router.push({
                  name: "properties",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      }
    },
      cancel: function () {
          if (this.buildingId == 0 || this.buildingId == null)
              this.$router.push("/buildings");
          else
      this.$router.push({
        name: "properties",
        params: {
          buildingId: this.buildingId,
          buildingName: this.buildingName,
        },
      });
    },
    addRow: function (index) {
      try {
        this.propertyHistory.splice(index, 0, {});
      } catch (e) {
        alert(e);
      }
    },
    removeRow: function (index) {
      this.propertyHistory.splice(index - 1, 1);
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    overallBalance: function () {
      var t = 0;
      for (var i = 0; i < this.propertyHistory.length; i++)
        t += this.propertyHistory[i].statement - this.propertyHistory[i].paid;
      /* $.each(this.propertyHistory, function (i, e) {
                t += e.statement - e.paid;
            });*/
      return t;
    },
  },
  // Our Javascript logic
};
</script>
